<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="gotoProductSub()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Product Sub Category
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="row d-flex justify-content-center">

                <div class="col-sm-12 col-md-5 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Product Category</mat-label>
                        <mat-select class="scrollbarcs" formControlName="productCategoryType"
                            placeholder="Please Select Product Category">
                            <mat-select-filter [displayMember]="'value'" [array]="filterPtoductList"
                                (filteredReturn)="PtoductList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of PtoductList" [value]="item.key"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-5 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Product Sub Category</mat-label>
                        <input matInput  maxlength="250" formControlName="subCategoryName"
                            placeholder="Enter Product Sub Category" required class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-5 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Connection Fee Type</mat-label>
                        <mat-select class="scrollbarcs" formControlName="connectionFeeType"
                            placeholder="Please Select Connection Fee Type">
                            <mat-select-filter [displayMember]="'value'" [array]="filterConnectionList"
                                (filteredReturn)="ConnectionList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of ConnectionList" [value]="item.key"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-5 mt-4"></div>
            </div>
            <div class="d-flex justify-content-center button-style">
                <button class="btn btn-primary mb-3 mr-3 mt-5" type="button" (click)="gotoProductSub()"
                    matButton>Cancel</button>
                <button class="btn btn-secondary mb-3 mt-5" (click)="onsubmit()" matButton>{{paramsid ===0
                    ?'Save': 'Update'}}</button>
            </div>
        </form>
    </div>
</div>